import React from 'react';

const Obituary: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto">
      {/* Section Title */}
      <div className="text-center mb-16">
        <h2 className="font-ornate text-4xl md:text-5xl text-burgundy-900 mb-4">Life Story</h2>
        <div className="flex items-center justify-center gap-4">
          <div className="w-16 h-px bg-gold-400/30"></div>
          <div className="text-gold-400 text-xl">✟</div>
          <div className="w-16 h-px bg-gold-400/30"></div>
        </div>
      </div>

      {/* Main Content Container */}
      <div className="relative">
        {/* Decorative corners */}
        <div className="absolute top-0 left-0 w-16 h-16 border-t-2 border-l-2 border-gold-400/20"></div>
        <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-gold-400/20"></div>
        <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-gold-400/20"></div>
        <div className="absolute bottom-0 right-0 w-16 h-16 border-b-2 border-r-2 border-gold-400/20"></div>

        {/* Content with padding for corners */}
        <div className="px-8 py-12">
          {/* Introduction */}
          <div className="mb-12 text-center">
            <p className="font-serif text-xl text-burgundy-800 italic mb-6">
              John David Smith lived a life marked by his deep love for education, family, and his Irish heritage. 
              Born in Tramore, Co. Waterford, on March 15, 1950, he brought warmth and wisdom to all who knew him 
              during his 74 remarkable years.
            </p>
          </div>

          {/* Life Story Sections */}
          <div className="space-y-12">
            {/* Education & Career */}
            <section className="relative">
              <h3 className="font-ornate text-2xl text-burgundy-800 mb-4">Education & Career</h3>
              <div className="prose prose-burgundy max-w-none font-serif">
                <p className="text-burgundy-700 leading-relaxed">
                  As a distinguished lecturer at South East Technological University (SETU), John inspired countless 
                  students with his passionate teaching and mentorship in the field of Engineering. His dedication to 
                  education and his unique ability to make complex subjects accessible endeared him to both students 
                  and colleagues alike.
                </p>
              </div>
            </section>

            {/* Favorite Quote */}
            <section className="relative">
              <div className="relative max-w-3xl mx-auto px-8 pt-6">
                <div className="absolute -top-1 -left-2 text-4xl text-gold-400/30 font-serif">"</div>
                <div className="absolute -top-1 -right-2 text-4xl text-gold-400/30 font-serif">"</div>
                <p className="font-serif text-xl italic text-burgundy-800 text-center">
                  Education is not just about teaching; it's about inspiring the next generation to believe in themselves.
                </p>
                <p className="text-center text-burgundy-700 mt-2">
                  — One of John's favorite sayings to his students
                </p>
              </div>
            </section>

            {/* Family Life */}
            <section className="relative">
              <h3 className="font-ornate text-2xl text-burgundy-800 mb-4">Family Life</h3>
              <div className="prose prose-burgundy max-w-none font-serif">
                <p className="text-burgundy-700 leading-relaxed">
                  Beyond the lecture hall, John was a devoted husband to Mary for 45 years, a loving father to John Jr. 
                  and Niamh, and a doting grandfather to his five grandchildren. His family was the center of his universe, 
                  and he took immense pride in their accomplishments and shared moments together.
                </p>
              </div>
            </section>

            {/* Heritage & Community */}
            <section className="relative">
              <h3 className="font-ornate text-2xl text-burgundy-800 mb-4">Heritage & Community</h3>
              <div className="prose prose-burgundy max-w-none font-serif">
                <p className="text-burgundy-700 leading-relaxed">
                  A proud Tramore native, John never lost touch with his roots. He was known for his storytelling at local 
                  gatherings, sharing tales of growing up by the sea and his adventures along the Waterford coast. His annual 
                  summer barbecues in his Tramore home became a cherished tradition, bringing together family, friends, and 
                  colleagues for afternoons filled with laughter, music, and his famous homemade brown bread.
                </p>
              </div>
            </section>
          </div>

          {/* Closing Message */}
          <div className="mt-16 text-center">
            <div className="relative max-w-3xl mx-auto px-8 pt-6">
              <div className="absolute -top-1 -left-2 text-4xl text-gold-400/30 font-serif">"</div>
              <div className="absolute -top-1 -right-2 text-4xl text-gold-400/30 font-serif">"</div>
              <p className="font-serif text-lg italic text-burgundy-700">
                John passed peacefully at home in Tramore, surrounded by his loving family. He is survived by his wife Mary, 
                children John Jr. and Niamh, their spouses, and five grandchildren who will carry forward his legacy of love, 
                learning, and Irish wit.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Obituary; 